import { useForm } from "react-hook-form";
import { RefPersonal } from "../../../models/ficha/RefPersonal";
import { InputComponent } from "../../../components/InputComponent";
import { ReferenciaPersonalService } from "../../../service/ficha/ReferenciaPersonalService";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { GenericComponent } from "../../../components/GenericComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Column } from "primereact/column";
import { TablaDinamica } from "../../../components/TablaDinamica";
import { useLazyParams } from "../../../hooks/useLazyParams";

export const ReferenciaPersonal = ({ tipo, id, toast, permss, num = 10, soloLectura }) => {

    const generic = new GenericComponent();
    const omodel = new RefPersonal();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const referenciaService = new ReferenciaPersonalService();
    const [dialogReferencia, setDialogReferencia] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [load, setLoad] = useState(false);
    const menuRef = useRef(null);
    const tablaPersonal = useLazyParams({ modelo: omodel.model });
    const { inText } = InputComponent({ registers: tablaPersonal.data, omodel, generic, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyPersonal();
        // eslint-disable-next-line
    }, [tablaPersonal.lazyParams, id]);

    const loadLazyPersonal = () => {
        tablaPersonal.setLoading(true);
        const _params = { ...tablaPersonal.lazyParams, idp: id, tipo: tipo };
        referenciaService.lista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaPersonal.setTotalRecords(res.data.total);
            tablaPersonal.setData(res.data.registros);
        }).finally(() => tablaPersonal.setLoading(false));
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogReferencia(true);
    }

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        setLoad(true);

        const request = getValues('id') == null ? referenciaService.nuevo(data) : referenciaService.editar(data);
        request.then(res => {
            setDialogReferencia(false);
            loadLazyPersonal();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoad(false);
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor complete los campos requeridos', life: 3000 });
    }

    const editPersonal = (data) => {
        reset(data);
        setDialogReferencia(true);
    }

    const confirmDelete = (data) => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deletePersonal(data)
        });
    };

    const deletePersonal = (data) => {
        referenciaService.eliminar(data?.id).then(res => {
            loadLazyPersonal();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editPersonal(registroSeleccionado) }] }];
        }

        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editPersonal(registroSeleccionado) });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado) });

        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_personal"
            aria-haspopup
            onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-rounded p-button-success" type="button" onClick={openNew} title="Registrar información" />
            )}
            <span className="font-bold">{num}.- Referencia Personal:</span>
        </div>
    );

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_personal" />
            <TablaDinamica
                modelo={omodel.model}
                estadoTabla={tablaPersonal}
                datos={tablaPersonal.data}
                totalRegistros={tablaPersonal.totalRecords}
                dataKey="id"
                acciones={ColumnaAcciones}
                header={cabeceraTabla()}
            />

            <Dialog visible={dialogReferencia} header={soloLectura ? "Ver Referencia Personal" : (getValues('id') == null ? "Nueva Referencia Personal" : "Editar Referencia Personal")} modal className="p-fluid modal-ssize"
                style={{ width: '400px' }} onHide={e => setDialogReferencia(false)}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-user text-primary"></i>
                                REFERENCIA PERSONAL
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>
                    <div className="formgrid grid">
                        {inText('nombres', { icon: 'pi pi-user' }, 12)}
                        {inText('parentesco', { icon: 'pi pi-users' }, 12)}
                        {inText('direccion', { icon: 'pi pi-map-marker' }, 12)}
                        {inText('telefono', { icon: 'pi pi-phone' }, 12)}
                    </div>

                    {soloLectura ? (
                        <div className="flex justify-content-end mt-3">
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={() => setDialogReferencia(false)} />
                        </div>
                    ) : (
                        generic.buttonsForms(setDialogReferencia, load)
                    )}
                </form>
            </Dialog>
        </>
    )
}
